import avatar from '../../assets/images/avatar.svg'
import {
  AvatarStyles,
  CardTourStyles,
  CardTourWithAvatarStyles,
} from './styles'

const TourDashboard = [
  {
    title: <AvatarStyles src={avatar} alt="avatar" />,
    content: (
      <CardTourWithAvatarStyles marginTop="40px">
        <span>Dúvidas sobre como análisar os resultados do Dashboard?</span>
        <br />
        <br />
        <strong> Vamos lá!</strong>
      </CardTourWithAvatarStyles>
    ),
    target: '#saudacao',
    placement: 'center',
  },
  {
    content: (
      <CardTourStyles marginTop="-20px">
        <p> Percentual geral</p>
        <span>
          Aqui você consegue visualizar a porcentagem de clientes e produtos que
          estão em alta ou baixa nas vendas de acordo com o período selecionado.
        </span>
      </CardTourStyles>
    ),
    target: '#dashboard',
    placement: 'bottom-fixed',
  },
  {
    content: (
      <CardTourStyles marginTop="-20px">
        <p>
          Percentual por produto <br /> ou cliente
        </p>
        <span>
          Selecionando a opção de <strong>em alta </strong> ou
          <strong> em baixa</strong> é possível analisar os produtos e clientes
          que possuem maiores ou menores percentuais de venda.
        </span>
      </CardTourStyles>
    ),
    target: '#table',
    placement: 'top-fixed',
  },
  {
    content: (
      <CardTourStyles marginTop="-20px">
        <p>
          Percentual por produto <br /> ou cliente
        </p>
        <span>
          Clicando em um dos produtos, é possível ver um detalhamento sobre os
          clientes em alta ou em baixa nas vendas do produto selecionado.
        </span>
      </CardTourStyles>
    ),
    target: '#itemProduto',
    placement: 'right',
  },
  {
    content: (
      <CardTourStyles marginTop="-20px">
        <p>
          Percentual por produto <br /> ou cliente
        </p>
        <span>
          Clicando em um dos clientes, é possível ver um detalhamento sobre os
          produtos que estão em alta ou em baixa nas vendas para este cliente.
        </span>
      </CardTourStyles>
    ),
    target: '#itemCliente',
    placement: 'left',
  },
  {
    title: <AvatarStyles src={avatar} alt="avatar" />,
    content: (
      <CardTourWithAvatarStyles marginTop="40px">
        <strong>Pronto!</strong>
        <br />
        <br />
        <span>Um passo a frente no follow up dos seus clientes!</span>
      </CardTourWithAvatarStyles>
    ),
    target: '#finalizacao',
    placement: 'center',
  },
]
export default TourDashboard
